__turbopack_context__.v({
  "className": "inter_1b5101b1-module__jNfeCa__className",
});
